export default __webpack_public_path__ + "static/media/10.91bcdb25.png";